import React from 'react';

const DashboardEmailTemplate = ({ recipientName, organizationName, dashboardTitle }) => {
  const currentYear = new Date().getFullYear();

  const getEmailBody = () => {
    return `
      <p>We hope you're doing well! We're excited to share the latest <strong>${dashboardTitle}</strong>.</p>
      <p>The full dashboard is attached as a PDF for your review.</p>
      <p style="margin-top: 30px;">Thank you for your engagement,<br>${organizationName} Team</p>
    `;
  };

  const htmlContent = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>${dashboardTitle} Dashboard</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          background-color: #f4f6f8;
          margin: 0;
          padding: 0;
        }
        .email-container {
          max-width: 600px;
          margin: 40px auto;
          background-color: #ffffff;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        }
        .email-header {
          background-color: #004aad;
          color: #ffffff;
          padding: 20px;
          text-align: center;
        }
        .email-body {
          padding: 30px 20px;
          color: #333333;
        }
        .email-footer {
          font-size: 12px;
          color: #999999;
          text-align: center;
          padding: 20px;
        }
        @media (max-width: 600px) {
          .email-body {
            padding: 20px 10px;
          }
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="email-header">
          <h2>${dashboardTitle}</h2>
        </div>
        <div class="email-body">
          <p>Hi ${recipientName},</p>
          ${getEmailBody()}
        </div>
        <div class="email-footer">
          © ${currentYear} ${organizationName}. All rights reserved.
        </div>
      </div>
    </body>
    </html>
  `;

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default DashboardEmailTemplate;